<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Editar cliente</h5>
        <div role="button" class="btn-close" @click="close"></div>
      </div>

      <div class="modal-body">
        <error-component :errors="errors" v-if="showError" />

        <form>
          <row-component>
            <col-component
              class-col="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12"
              :class="{ formError: errors.client_id }"
            >
              <label>Cliente:</label>
              <div class="input-container">
                <input-component v-model="selectedClientName" disabled />
                <button-submit class="btn-modal-search" icon="search" @click="openModalClient = true" />
              </div>
            </col-component>

            <col-component
              class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
              :class="{ formError: errors.freight_price }"
            >
              <label>Valor frete:</label>
              <input-component v-model="formData.freight_price" v-money="MONEY" />
            </col-component>
          </row-component>

          <row-component>
            <col-component
              class-col="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
              :class="{ formError: errors.description }"
            >
              <label>Descrição:</label>
              <text-area v-model="formData.description" rows="6" />
            </col-component>
          </row-component>

          <div class="text-end mt-3">
            <button-submit :disabled="sendForm" icon="save" name="Salvar" @click="submit" />
          </div>
        </form>
      </div>
    </div>

    <OrderPartClientSearch
      v-if="openModalClient"
      @close="openModalClient = false"
      @select="handleClientSelection"
    />
  </div>
</template>

<script>
import RowComponent from '@/components/row/RowComponent.vue';
import ColComponent from '@/components/row/ColComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import TextArea from '@/components/form/TextArea.vue';
import ButtonSubmit from '@/components/buttons/ButtonSubmit.vue';
import ErrorComponent from '@/components/alerts/ErrorComponent.vue';
import OrderPartClientSearch from '@/components/modal/OrderPartClientSearch.vue';
import { VMoney } from 'v-money';
import { MONEY } from '@/configs/constants';
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
  name: 'OrderPartEditClient',

  components: {
    RowComponent,
    ColComponent,
    InputComponent,
    TextArea,
    ButtonSubmit,
    ErrorComponent,
    OrderPartClientSearch
  },

  directives: {
    money: VMoney
  },

  props: {
    itemData: {
      type: Object,
      required: true
    }
  },

  created() {
    this.formData.client_id = this.itemData.client_id;
    this.formData.freight_price = this.itemData.freight_price || '0,00';
    this.formData.description = this.itemData.description || '';
    this.selectedClientName = this.itemData.client_name || '';
  },

  data() {
    return {
      MONEY,
      selectedClientName: '',
      openModalClient: false,
      formData: {
        client_id: '',
        freight_price: '0,00',
        description: ''
      },
      errors: [],
      showError: false,
      sendForm: false
    };
  },

  methods: {
    close() {
      this.$emit('close');
    },

    handleClientSelection(client) {
      this.formData.client_id = client.id;
      this.selectedClientName = client.surname || client.name;
      this.openModalClient = false;
    },

    submit() {
      if (this.sendForm) return;
      this.sendForm = true;

      this.$store
        .dispatch('updateOrderPart', {
          id: this.itemData.id,
          client_id: this.formData.client_id,
          freight_price: this.formData.freight_price,
          description: this.formData.description
        })
        .then(() => {
          this.sendForm = false;
          toast.success('Cadastro atualizado com sucesso', { timeout: 1500 });
          this.$emit('saved');
          this.close();
        })
        .catch(e => {
          this.sendForm = false;
          this.showError = true;
          this.errors = e.response?.data?.errors || [];
          toast.error('Erro ao atualizar cadastro', { timeout: 1500 });
        });
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 1100px;
  max-width: 90%;
  position: relative;
  max-height: 80%;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.btn-modal-search {
  padding-top: 9.5px;
  padding-bottom: 5px;
}
</style>
